import React, { useState } from 'react';
import { Button, Skeleton } from 'antd';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import SubjectSelectModal from '../subject-select-modal';

const LeftSideSubjectCard = () => {
  const [open, setOpen] = useState(false);
  const loading = useAppSelector(state => state.user.loading);
  const t = useTranslations('profile');

  if (loading) {
    return (
      <div className="mt-5 w-[337px] rounded-xl bg-white p-4">
        <div className="flex items-center gap-3">
          <Skeleton.Avatar size={60} active shape="circle" />
          <div>
            <Skeleton.Input className="mb-1 !h-4 !w-40" active />
            <Skeleton.Input className="!h-3 !w-52" active />
          </div>
        </div>
        <div className="mt-3">
          <Skeleton.Button className="!h-12 !w-full !rounded-lg" active />
        </div>
      </div>
    );
  }

  return (
    <div className="mt-5 w-full rounded-xl bg-white p-4">
      <div className="flex items-center gap-3">
        <div>
          <div className="w-17 h-17 flex items-center justify-center rounded-full bg-orange-50">
            <div className="relative size-9">
              <Image src="/images/book-subject.webp" fill alt="Geography globs" title="GLOBUS" />
            </div>
          </div>
        </div>
        <div>
          <h2 className="mb-1 text-sm font-semibold text-gray-700">{t('left_side.qaysi_fanni_organmoqchisiz')}</h2>
          <p className="text-xs text-gray-500">{t('left_side.qaysi_fanni_organmoqchisiz_desc')}</p>
        </div>
      </div>
      <div className="mt-3">
        <Button
          onClick={() => setOpen(true)}
          className="!w-full !rounded-lg !border-2  !border-gray-200 !py-5 !text-green-500 hover:!border-green-500"
        >
          {t('left_side.tanlash')}
        </Button>
      </div>

      <SubjectSelectModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default LeftSideSubjectCard;
